// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AppleOutlinedSvg from "@ant-design/icons-svg/es/asn/AppleOutlined";
import AntdIcon from '../components/AntdIcon';

var AppleOutlined = function AppleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AppleOutlinedSvg
  }));
};

AppleOutlined.displayName = 'AppleOutlined';
export default React.forwardRef(AppleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AppleOutlined.js
// module id = 581
// module chunks = 0